import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect, useRef } from 'react';
import {
  BarChart,
  XAxis,
  YAxis,
  Bar,
  LabelList
} from 'recharts'

const MissedInspectionsChartWidget = ({totalCounts} :any) => {  
  const [containerWidth, setContainerWidth] = useState(600);
  const containerRef = useRef<HTMLElement>(null);

  const COLORS = {
    missed: '#FF4C51',
    submitted: '#28C76F',
  };

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const width = containerRef.current.clientWidth;

        setContainerWidth(Math.max(width - 60, 500));
      }
    };

    setTimeout(updateWidth, 100);
    
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  let totalCount = totalCounts.allRegionsTotalInspectionsCount || totalCounts.allDivisionsTotalInspectionsCount
  let missedCount = totalCounts.allRegionsMissedInspectionsCount || totalCounts.allDivisionsMissedInspectionsCount
  let submittedCount = totalCount - missedCount
  
  let missedPercentage = 0

  if (totalCount > 0) {
    missedPercentage = parseFloat(((missedCount / totalCount) * 100).toFixed(1))
  }
  let submittedPercentage = parseFloat((100 - missedPercentage).toFixed(1))

  const data = [
    {
      name: 'Inspections',
      missed: missedPercentage,
      submitted: submittedPercentage,
      missedPercentage: `${missedPercentage}%`,
      submittedPercentage: `${submittedPercentage}%`,
    },
  ];
  
  return (
    <>
      <div className="missed-inspections-chart-widget">
        <header className="missed-inspections-chart-widget__header">
          <h2 className="missed-inspections-chart-widget__title">Missed Inspections</h2>
          <h2 className="missed-inspections-chart-widget__totalCount">{totalCounts.allRegionsMissedInspectionsCount || totalCounts.allDivisionsMissedInspectionsCount}</h2>
        </header>

        <div>
          <div className="missed-inspections-chart-widget__body">
            <div className="missed-inspections-chart-widget__content">
              <section className="missed-inspections-chart-widget__content-top" ref={containerRef}>
                <BarChart
                  width={containerWidth}
                  height={200}
                  data={data}
                  layout="vertical"
                  margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                  barCategoryGap="10%"
                >
                  <XAxis
                    type="number"
                    domain={[0, 100]}
                    tick={{ fontSize: 12 }}
                    axisLine={true}
                    allowDataOverflow={true} 
                  />
                  <YAxis
                    type="category"
                    dataKey="name"
                    axisLine={false}
                    tick={false}
                  />

                  <Bar dataKey="missed" stackId="a" fill={COLORS.missed} name="Missed Inspections" barSize={80}>
                    <LabelList dataKey="missedPercentage" position="insideLeft" fill="#FFF" />
                  </Bar>
                  <Bar dataKey="submitted" stackId="a" fill={COLORS.submitted} name="Submitted On Time" barSize={80}>
                    <LabelList dataKey="submittedPercentage" position="insideRight" fill="#FFF" />
                  </Bar>
                </BarChart>
              </section>

              <section className="missed-inspections-chart-widget__content-bottom">
                <div>
                  <span>
                    <FontAwesomeIcon icon={faSquare} color={COLORS.missed}/>
                    <h4>Missed Inspection</h4>
                    <h4>{missedCount}</h4>
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faSquare} color={COLORS.submitted}/>
                    <h4>Submitted On Time</h4>
                    <h4>{submittedCount}</h4>
                  </span>
                </div>
                <div>
                  <span>
                    <h4>Missed Rate</h4>
                    <h4>{`${missedPercentage}%`}</h4>
                  </span>
                  <span>
                    <h4>Submitted Rate</h4>
                    <h4>{`${submittedPercentage}%`}</h4>
                  </span>
                </div>
                <div>
                  <h4>Total Inspections: {totalCount}</h4>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MissedInspectionsChartWidget